import { FaInfoCircle } from '@meronex/icons/fa';
import { uniqueId } from 'lodash-es';
import React, { useCallback, useContext, useRef } from 'react';
import globalFocus from '../../../../../utils/globalFocus';
import { IconButton } from '../../../../common';
import { TUploaderFileInfo } from '../../../../common/uploader/types';
import { OpenModalContext } from '../../../common/modals/OpenModalContext';

const InfoButton = ({ file }: { file: TUploaderFileInfo }) => {
  const { isLoading, show } = useContext(OpenModalContext);

  const id = React.useMemo(uniqueId, []);

  const ref = useRef<HTMLButtonElement | null>(null);
  const onClick = useCallback(() => {
    show();
    globalFocus.focus = () => {
      return document.getElementById(`info${file.docId}${id}`) as HTMLElement;
    };
  }, [id, show, file]);

  return (
    <IconButton
      ref={ref}
      className="uploader-list__buttons__down"
      id={`info${file.docId}${id}`}
      icon={FaInfoCircle}
      iconSize={20}
      isLoading={isLoading}
      onClick={onClick}
      size={32}
      title={window.BTN_FILE_INFO_LBL}
      disabled={!file.canRead && !file.canEdit}
    />
  );
};

export default InfoButton;
